import React from 'react';
import { useSelector } from 'react-redux';
import { version } from '../../../version.json';

export default function FooterAdmin() {
  const information = useSelector((state) => state.information);
  return (
    <>
      <footer className="block py-4">
        <div className="hidden lg:block container mx-auto px-4 print-disable">
          <hr className="mb-4 border-b-1 border-gray-300" />
          <div className="flex flex-wrap items-center md:justify-between justify-center">
            <div className="w-full md:w-4/12 px-4">
              <div className="text-sm text-gray-600 font-semibold py-1 text-center md:text-left">
                Copyright © {new Date().getFullYear()}{' '}
                <a
                  href={information?.system_url}
                  className="text-gray-700 hover:text-gray-900 text-sm font-semibold py-1"
                >
                  {information?.system_owner_name} <br />{' '}
                  <span className="text-xs">Version {version} </span>
                </a>
              </div>
            </div>
            <div className="w-full md:w-8/12 px-4">
              <ul className="flex flex-wrap list-none md:justify-end  justify-center">
                <li>
                  <a
                    href={information?.system_sponsor_url}
                    className="text-gray-700 hover:text-gray-900  text-sm font-semibold block py-1 px-3"
                  >
                    {information?.system_sponsor}
                  </a>
                </li>
                <li>
                  <a
                    href="https://iarc.psu.ac.th/"
                    className="text-gray-700 hover:text-gray-900 text-sm font-semibold block py-1 px-3"
                  >
                    IARC PSU
                  </a>
                </li>

                {/* <li>
                  <a
                    href="https://github.com/creativetimofficial/notus-react/blob/master/LICENSE.md?ref=nr-footer-admin"
                    className="text-gray-700 hover:text-gray-900 text-sm font-semibold block py-1 px-3"
                  >
                    MIT License
                  </a>
                </li> */}
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
